<template>
<div class="chapter">
<div class="inner_page">
<h2 style="font-family: Calisto MT;">I Found Him on the Internet</h2>
<ul style="font-family: Calisto Mt; margin-left: -10px; margin-top: 20px; font-weight: normal !important;">
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Copyright Information ©</a></li>
<li><a href="#/index_split_002#toc_id_3">Acknowledgement</a></li>
<li><a href="#/index_split_004#id_Toc151733073">I Found Him on the Internet</a></li>
<li><span href="#/index_split_005#id_Toc151733074" title="Link target outside of Sample">Open Your Legs, Professor</span></li>
<li><span href="#/index_split_006#id_Toc151733075" title="Link target outside of Sample">The Story of Adam Einsam</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0dd69bbf